module.exports = __webpack_public_path__ + "static/media/maker_launch.d043e42e.svg";